import web from "../web";

class NiveauxService {
    index(token){
        return web.get("/api/niveaux", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/niveaux", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/niveaux/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/niveaux/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/niveaux/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new NiveauxService()